import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-e7275b9a"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "container mt-5" };
var _hoisted_2 = {
    key: 0,
    class: "mt-7"
};
var _hoisted_3 = {
    key: 0,
    class: "grid grid-cols-12 gap-y-4 mt-5 courses sm:gap-x-8 md:gap-y-6"
};
var _hoisted_4 = {
    key: 1,
    class: "mt-7 text-gray-400 text-center"
};
var _hoisted_5 = {
    key: 2,
    class: "mt-7 text-gray-400 flex gap-4 flex-col items-center text-center"
};
import cardCourse from '@student/components/Elements/CardCourse.vue';
import { sortArray } from '@common/utils/Array/Array';
import { CoreStore } from '@student/modules/store';
import Auth from '@common/modules/auth';
import Api from '@student/modules/api/api';
import { computed, onMounted, ref, watch } from 'vue';
import ESearch from '@common/ui/ESearch.vue';
import EButton from "@common/ui/EButton.vue";
import { useRouter } from "vue-router";
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CoursesLibrary',
    setup: function (__props) {
        var t = useI18n().t;
        var searchQuery = ref('');
        var courses = ref([]);
        var loading = ref(false);
        var router = useRouter();
        var myCourses = computed(function () {
            var query = searchQuery.value.toLowerCase().replace(/\s+/, '');
            var coursesLocal = courses.value.filter(function (course) {
                if (searchQuery.value !== '') {
                    var courseName = course.name.toLowerCase().replace(/\s+/, '');
                    // Если совпадение по названию категории - отображаем
                    var categoryMatch = course.categories.find(function (category) {
                        var categoryName = category.name.toLowerCase().replace(/\s+/, '');
                        return categoryName.includes(query);
                    });
                    // Если нет совпадений по навзанию или категориям - скрываем
                    if (!courseName.includes(query) && !categoryMatch) {
                        return false;
                    }
                }
                return course.allowed;
            });
            // Сортируем категории
            coursesLocal = sortArray(coursesLocal, function (course) {
                return course.categories && course.categories.length > 0 ? (course.categories[0].order * 10) + course.categoryOrders[course.categories[0].id] : 100000 + course.order;
            }, 'asc');
            return coursesLocal;
        });
        var user = computed(function () { return Auth.getUser(); });
        var school = computed(function () { return CoreStore.school; });
        var getCourses = function () {
            loading.value = true;
            Api.getCourses().then(function (res) {
                var data = res.data;
                courses.value = data;
                loading.value = false;
            });
        };
        var handleClearSearch = function () {
            searchQuery.value = '';
        };
        var goToSchoolCourses = function () {
            router.push({ name: 'schoolCourses' }).catch(function () { });
        };
        watch(user, function () {
            getCourses();
        });
        onMounted(function () {
            getCourses();
        });
        return function (_ctx, _cache) {
            var _directive_loading = _resolveDirective("loading");
            return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(ESearch, {
                    modelValue: searchQuery.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((searchQuery).value = $event); }),
                    class: _normalizeClass(searchQuery.value && 'text-center'),
                    placeholder: _unref(t)('search.placeholder'),
                    theme: "gray",
                    onClear: handleClearSearch
                }, null, 8, ["modelValue", "class", "placeholder"]),
                (myCourses.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (courses.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myCourses.value, function (course) {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: course.id,
                                        class: "col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3"
                                    }, [
                                        _createVNode(cardCourse, {
                                            course: course,
                                            class: "h-full",
                                            "show-all-categories": ""
                                        }, null, 8, ["course"])
                                    ]));
                                }), 128))
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : (myCourses.value.length === 0 && searchQuery.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)('courses.notFound')), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createTextVNode(_toDisplayString(_unref(t)('courses.notEnrolled')) + " ", 1),
                            _createVNode(EButton, {
                                type: "primary",
                                onClick: goToSchoolCourses
                            }, {
                                default: _withCtx(function () { return [
                                    _createTextVNode(_toDisplayString(_unref(t)('courses.goToCatalog')), 1)
                                ]; }),
                                _: 1
                            })
                        ]))
            ])), [
                [_directive_loading, loading.value]
            ]);
        };
    }
});
